module.exports = __webpack_public_path__ + "static/media/i_fr.4f30e44a.pdf";